import React from "react";
import {
  FormControl,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
function configureUserToDC() {
   
    return (
      <>
        <Table
          aria-labelledby={"tableMenuTitle"}
          size={"small"}
          aria-label={"configuration table"}
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={"configureHeader"}
                className={"content-header"}
                colSpan={2}
              >
                <div className={"content-header d-flex"}>
                  {" "}
                  <div
                    className={"col-xs-11"}
                    style={{ display: "inline-block", alignItems: "center" }}
                  >
                    {"Configure Users Data Center\r"}
                  </div>
                  <div className={"col-xs-1"}>
                    <Tooltip title={"Save"}>
                      <IconButton size={"small"} style={{ color: "#FFFFFF" }}>
                        <SaveIcon size={"small"} style={{ fill: "#FFFFFF" }} />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              </TableCell>
              {/* <TableCell style={{ textAlign: "right" }}>
             
            </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{" Select Data Center"}</TableCell>
              <TableCell>
                {" "}
                <FormControl style={{ minWidth: 300 }}>
                  {/* <InputLabel id="demo-multiple-chip-label">With</InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    style={{ width: "100%" }}
                    value={this.state.SelectedDC}
                    onChange={(e) => this.handleChange(e.target.value, "value")}
                    input={<Input id="select-multiple-chip" />}
                    renderValue={(selected) => (
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {selected.map((value, index) => (
                          <Chip
                            key={value + index}
                            label={value}
                            style={{ margin: "2px" }}
                            onDelete={() => this.handleChange(value, "chip")}
                            onMouseDown={(event) => {
                              event.stopPropagation();
                            }}
                          />
                        ))}
                      </div>
                    )}
                    MenuProps={MenuProps}
                  >
                    {(this.state.datacenterList || []).map((item) => (
                      <MenuItem key={item.propertyID} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select> */}
                </FormControl>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>{" Select Patrol Type"}</TableCell>
              <TableCell>
                {/* <Select
                  style={{ minWidth: 300 }}
                  native
                  onChange={(e) =>
                    this.setState({
                      PatrolType: e.target.value,
                      SaveStatus: true,
                    })
                  }
                >
                  <option aria-label="None" value={this.state.PatrolType} />
                  <option value={17}>Security - Physical Patrol</option>
                  <option value={19}>Security - Virtual Patrol</option>
                </Select> */}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>{" Enter Patrols Per Day"}</TableCell>
              <TableCell>
                {" "}
                {/* <TextField
                  style={{ minWidth: 300 }}
                  id="standard-basic"
                  type="number"
                  InputProps={{ inputProps: { min: 0, max: 10000 } }}
                  onChange={(e) =>
                    this.handelPatrolDayChange(parseFloat(e.target.value))
                  }
                />{" "} */}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{" Total Scheduled Patrols For Month"}</TableCell>
              <TableCell>
                {" "}
                {/* <span>{this.state.PatrolsPerMonth}</span> */}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  
}

export default configureUserToDC;
